module.exports = __webpack_public_path__ + "static/media/cloudComputing-min.a18de61d.jpg";